import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, X } from 'lucide-react';
import { Dialog, DialogContent } from '../components/ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GalleryPage = () => {
  const [images, setImages] = useState([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const response = await axios.get(`${API}/gallery`);
        setImages(response.data);
      } catch (error) {
        console.error('Error fetching gallery:', error);
      }
    };
    fetchGallery();
  }, []);

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  const navigateLightbox = (dir) => {
    setLightboxIndex((prev) => (prev + dir + images.length) % images.length);
  };

  return (
    <div className="min-h-screen bg-[#0A3D62]" data-testid="gallery-page">
      {/* Header */}
      <div className="bg-[#072942] border-b-2 border-[#1a5276]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6">
          <div className="flex items-center gap-4">
            <Link to="/" className="w-10 h-10 rounded-full bg-[#0A3D62] flex items-center justify-center text-white hover:bg-accent/20 transition-colors" data-testid="back-to-home">
              <ArrowLeft className="w-5 h-5" />
            </Link>
            <div>
              <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white">Photo Gallery</h1>
              <p className="text-white/60 text-sm">Thai Franchise Global Move 2026</p>
            </div>
          </div>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        {images.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
            {images.map((img, index) => (
              <div
                key={img.id}
                className="group relative aspect-square overflow-hidden rounded-lg border-2 border-[#1a5276] hover:border-accent/50 transition-all cursor-pointer"
                onClick={() => openLightbox(index)}
                data-testid={`gallery-thumb-${index}`}
              >
                <img
                  src={img.image_url}
                  alt={img.caption || `Gallery ${index + 1}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                {img.caption && (
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 opacity-0 group-hover:opacity-100 transition-opacity">
                    <p className="text-white text-xs sm:text-sm truncate">{img.caption}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-24">
            <p className="text-white/40 text-lg">Gallery images coming soon</p>
          </div>
        )}
      </div>

      {/* Lightbox */}
      <Dialog open={lightboxOpen} onOpenChange={setLightboxOpen}>
        <DialogContent hideCloseButton className="max-w-5xl bg-black/95 border-none p-2" data-testid="gallery-lightbox">
          <button
            onClick={() => setLightboxOpen(false)}
            className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-white hover:bg-white/30 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
          {images.length > 0 && (
            <>
              <img
                src={images[lightboxIndex]?.image_url}
                alt={images[lightboxIndex]?.caption || 'Gallery image'}
                className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
              />
              {images[lightboxIndex]?.caption && (
                <p className="text-white/80 text-center mt-2 text-sm">{images[lightboxIndex].caption}</p>
              )}
              {images.length > 1 && (
                <div className="flex justify-center gap-4 mt-4">
                  <button onClick={() => navigateLightbox(-1)} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20">&larr;</button>
                  <span className="text-white/60 self-center text-sm">{lightboxIndex + 1} / {images.length}</span>
                  <button onClick={() => navigateLightbox(1)} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20">&rarr;</button>
                </div>
              )}
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default GalleryPage;
